import { useEffect, useRef } from "react";
import { getStoredToken } from "@/types";
import type { Interview } from "@/types";

// Connects to the SSE endpoint and calls onUpcoming whenever the server pushes
// upcoming-interview events. Handles reconnection automatically (EventSource retries).
export function useInterviewSSE(onUpcoming: (interviews: Interview[]) => void) {
  const cbRef = useRef(onUpcoming);
  cbRef.current = onUpcoming;

  useEffect(() => {
    const token = getStoredToken();
    if (!token) return;

    const es = new EventSource(`/api/interviews/sse?token=${encodeURIComponent(token)}`);

    es.addEventListener("upcoming", (e: Event) => {
      try {
        const { interviews } = JSON.parse((e as MessageEvent).data) as { interviews: Interview[] };
        cbRef.current(interviews ?? []);
      } catch {
        // malformed event — ignore
      }
    });

    return () => es.close();
  }, []); // only mount/unmount — token and cbRef handle the rest
}
